import styled from '@emotion/styled'

export const ThemeFormModalFrame = styled.div`
  /* fit-content, а не auto(=100%): иначе обёртка Modal раздувается до 95vw и
     модалка становится дико широкой с пустым местом справа. */
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;

  .theme-form-modal {
    /* Влезаем в белый блок Modal (95vw минус его паддинг 25px×2), иначе контент
       вылезает за края. Сверху ограничено 1080px для широких экранов. */
    width: min(1080px, calc(95vw - 50px));
    max-width: min(1080px, calc(95vw - 50px));
    /* Высота по контенту: не форсим высокую модалку (иначе лишний скролл и
       обрезка кнопок снизу). Ограничиваем только сверху размером экрана. */
    height: auto;
    min-height: 0;
    max-height: calc(100dvh - 64px);
    overflow: hidden auto;
    min-width: 0;
    box-sizing: border-box;
    justify-content: flex-start;
    align-items: stretch;
  }

  .theme-form-modal,
  .theme-form-modal > div {
    display: flex;
    flex-direction: column;
  }

  .theme-form-modal > div {
    min-width: 0;
    min-height: 0;
  }

  .theme-form-modal > div:first-of-type {
    flex: 1 0 auto;
    min-height: 0;
    justify-content: flex-start;
  }

  .theme-form-modal > div > div:first-of-type {
    min-width: 0;
  }

  .theme-form-modal > div > div:first-of-type > div:first-of-type {
    height: auto;
    margin-bottom: 12px;
  }

  .theme-form-modal h1,
  .theme-form-modal h2 {
    margin: 0;
    font-size: 28px;
    line-height: 34px;
    font-weight: 700;
    letter-spacing: 0;
    white-space: normal;
  }

  #content {
    width: min(912px, 100%);
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 0;
  }

  #theme-modal-instructions,
  #theme-modal-control-question,
  #contentFields {
    width: 100%;
    max-width: 912px;
    min-width: 0;
    box-sizing: border-box;
  }

  #theme-modal-instructions {
    margin-bottom: 0;
  }

  #contentFields {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  #content > div,
  #contentFields > div {
    margin-bottom: 0;
  }

  #theme-main-fields > div {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
  }

  #theme-hours-field > div {
    display: flex;
    align-items: flex-start;
    gap: 0;
  }

  #theme-main-fields > div > label:first-of-type {
    width: 352px;
  }

  #theme-main-fields > div > label:last-of-type {
    width: 260px;
  }

  #theme-hours-field > div > label {
    width: 261px;
  }

  #theme-main-fields > div > label,
  #theme-hours-field > div > label {
    gap: 12px;
    padding-top: 0;
  }

  #theme-main-fields > div > label > div:first-of-type,
  #theme-hours-field > div > label > div:first-of-type {
    height: 16px;
    margin-bottom: 0;
    align-items: flex-start;
    white-space: nowrap;
  }

  #theme-main-fields > div > label > span,
  #theme-hours-field > div > label > span {
    text-transform: uppercase;
    letter-spacing: 0.1em;
    white-space: nowrap;
  }

  #content input:not([type='radio']),
  #content textarea {
    border-radius: 25px;
    padding: 10px 16px;
    font-size: 14px;
    line-height: 20px;
  }

  #content input:not([type='radio']) {
    height: 40px;
  }

  #theme-modal-control-question {
    margin-top: 0;
  }

  .theme-form-modal > div:last-child {
    width: 419px;
    min-height: 0;
    flex: none;
    margin: 0 0 0 auto;
    padding-top: 32px;
    /* flex-end, а не grid: при редактировании кнопка «Сохранить» одна (без «Сохранить
       и добавить еще»), и в 2-колоночном гриде она садилась в левую колонку у середины.
       flex-direction: row ОБЯЗАТЕЛЕН — иначе футер наследует column от правила
       ".theme-form-modal > div", и justify-content: flex-end прижимает кнопку вниз, а
       не вправо (она уезжает влево и выглядит по центру). */
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: flex-end;
    flex-wrap: nowrap;
    box-sizing: content-box;
  }

  #modal-save-and-add-more,
  #modal-save {
    height: 40px;
    border-radius: 20px;
    padding: 10px 20px;
    font-size: 12px;
    line-height: 15px;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    box-sizing: border-box;
    justify-content: center;
    white-space: nowrap;
  }

  #modal-save-and-add-more {
    width: 270px;
    min-width: 270px;
    color: #000000;
    background: #ffffff;
  }

  #modal-save {
    width: 133px;
    min-width: 133px;
  }

  /* Каталожный режим (Витрина): футер — простой ряд во всю ширину, кнопка(и)
     прижаты вправо (внутренний grid 270/133 тут не нужен). */
  .theme-form-modal--catalog > div:last-child {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    grid-template-columns: none;
    margin: 0;
    gap: 16px;
  }

  /* Чекбокс "Содержит тест" (последнее поле каталожной строки) без верхнего лейбла
     висел на уровне лейблов — опускаем к нижнему краю строки, на уровень инпутов. */
  #theme-catalog-fields label:last-child {
    align-self: flex-end;
  }

  /* Селект "Выбрать SCORM": общий стиль #content input (height:40 + padding)
     раздувал внутренний input react-select, из-за чего плейсхолдер съезжал вниз.
     Сбрасываем его — плейсхолдер центрируется в 40px-контроле. */
  #theme-catalog-fields [class*='control'] input {
    height: auto;
    min-height: 0;
    padding: 0;
    border-radius: 0;
  }

  @media (max-height: 1180px) and (min-width: 901px) {
    #content {
      gap: 14px;
    }

    #contentFields {
      gap: 10px;
    }

    #theme-modal-control-question {
      margin-top: 0;
    }

    .theme-form-modal > div:last-child {
      padding-top: 24px;
    }
  }

  @media (max-height: 980px) and (min-width: 901px) {
    #content {
      gap: 10px;
    }

    #contentFields {
      gap: 8px;
    }

    #theme-modal-instructions ul {
      line-height: 24px;
    }

    #theme-modal-control-question > div {
      gap: 8px;
    }

    #theme-modal-control-question textarea {
      height: 56px;
      min-height: 56px;
    }

    .theme-form-modal > div:last-child {
      padding-top: 18px;
    }
  }

  @media (max-height: 850px) and (min-width: 901px) {
    .theme-form-modal > div > div:first-of-type > div:first-of-type {
      margin-bottom: 4px;
    }

    #content {
      gap: 6px;
    }

    #contentFields {
      gap: 4px;
    }

    #theme-modal-instructions ul {
      padding-top: 6px;
      padding-bottom: 6px;
      font-size: 14px;
      line-height: 20px;
    }

    #theme-modal-control-question > div {
      gap: 4px;
    }

    #theme-modal-control-question > div > div:first-of-type {
      margin-bottom: 0;
    }

    #theme-modal-control-question textarea {
      height: 48px;
      min-height: 48px;
    }

    #theme-modal-control-question > div > div:nth-of-type(3) {
      margin-top: 8px;
      gap: 8px;
    }

    #theme-modal-control-question > div > div:nth-of-type(3) > div:nth-of-type(2) {
      gap: 6px;
    }

    .theme-form-modal > div:last-child {
      padding-top: 6px;
    }

    #modal-save-and-add-more,
    #modal-save {
      height: 40px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }

  @media (max-width: 900px) {
    width: 100%;

    .theme-form-modal {
      width: min(100%, calc(100vw - 34px));
      max-width: calc(100vw - 34px);
      max-height: calc(100vh - 68px);
      height: auto;
      min-width: 0;
      overflow-y: auto;
    }

    .theme-form-modal > div {
      min-width: 0;
    }

    .theme-form-modal > div:first-of-type {
      flex: none;
    }

    .theme-form-modal > div > div:first-of-type > div:first-of-type {
      margin-bottom: 12px;
    }

    .theme-form-modal h1,
    .theme-form-modal h2 {
      font-size: 22px;
      line-height: 28px;
      text-align: center;
      width: 100%;
    }

    #content {
      width: 100%;
      gap: 24px;
    }

    #content,
    #contentFields,
    #content > div,
    #theme-main-fields > div,
    #theme-hours-field > div,
    #theme-modal-instructions,
    #theme-modal-control-question {
      max-width: 100%;
    }

    #theme-main-fields > div,
    #theme-hours-field > div {
      flex-direction: column;
      gap: 12px;
      width: 100%;
    }

    #theme-main-fields,
    #theme-hours-field,
    #theme-file,
    #theme-main-fields > div > label,
    #theme-hours-field > div > label {
      min-width: 0;
      box-sizing: border-box;
    }

    #theme-main-fields > div > label:first-of-type,
    #theme-main-fields > div > label:last-of-type,
    #theme-hours-field > div > label {
      width: 100%;
      max-width: 100%;
    }

    #theme-main-fields > div > label > span,
    #theme-hours-field > div > label > span {
      white-space: normal;
    }

    #theme-file button {
      width: 100%;
      min-width: 0;
    }

    #theme-modal-control-question {
      margin-top: 0;
    }

    .theme-form-modal > div:last-child {
      width: 100%;
      margin: 24px 0 0;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    #modal-save-and-add-more,
    #modal-save {
      width: 100%;
      min-width: 0;
      min-height: 44px;
      height: auto;
      padding: 14px 15px;
      line-height: 15px;
      white-space: normal;
    }
  }
`

export const InstructionList = styled.ul`
  width: min(912px, 100%);
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 16px 16px 16px 40px;
  list-style: disc;
  font-size: 16px;
  line-height: 28px;
  color: #1d4e89;
  background: #f2f6fa;
  border-radius: 24px;

  li {
    margin-bottom: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: 900px) {
    padding: 16px 18px 16px 40px;
    font-size: 16px;
    line-height: 24px;
  }
`
